import React, { useState } from 'react'
import AllRoutes from './AllRoutes';
import { Provider } from 'react-redux';
import store from './helper/Redux/store';
import { AuthProvider } from './helper/Context/context';

const App = () => {

  return (
    <>
      <Provider store={store}>
        <AuthProvider>
          <AllRoutes />
        </AuthProvider>
      </Provider>
    </>

  )
}

export default App